





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Login extends Vue {
  @Prop({default: "Ohai"}) private msg!: string;

  private cookieContents: object = {};
  private userid = "";
  private password = "";
  private alertText = "";

  @Watch('userid')
  watchUserID() {
    this.alertText = "";
  }

  @Watch('password')
  watchPassword() {
    this.alertText = "";
  }

  async login() {
    this.alertText = "";
    try {
      const response = await this.$http.post(
        '/user/login',
        { 
          userid: this.userid,
          password: this.password
        }
      );
      this.$store.commit('setUser', { user: response.data } );
      this.$router.push('/');
    } catch (err) {
      this.alertText = err.response.data;
    }
  }
}

